import { BlockedIcon, DeleteIcon, FlagIcon } from '@/assets/icons';

export interface SettingsData {
    titleTranslationKey: string;
    typeTranslationKey: string;
    icon: React.FC;
    action: 'block' | 'complain' | 'clear_chat';
}

export const settingsData: SettingsData[] = [
    {
        titleTranslationKey: 'msgs.clear_chat_with',
        typeTranslationKey: 'msgs.clear_chat_with_desc',
        icon: BlockedIcon,
        action: 'clear_chat',
    },
    {
        titleTranslationKey: 'msgs.block_user',
        typeTranslationKey: 'msgs.block_user_desc',
        icon: DeleteIcon,
        action: 'block',
    },
    {
        titleTranslationKey: 'msgs.complaint_to',
        typeTranslationKey: 'msgs.complaint_to_desc',
        icon: FlagIcon,
        action: 'complain',
    },
];
